import { createAction, props } from "@ngrx/store";
import IUserSkill from "@skills-app/models/userSkills";
import { ISkillNode } from "@skills-app/models/skillNode";

const prefix = "[Skill Champion Page]";

export const clearSkillChampions = createAction(
  `${prefix} Clear Skill Champions`,
);

export const selectConsultants = createAction(
  `${prefix} Select Consultants`,
  props<{ consultants: IUserSkill[] }>(),
);
export const addToSelectedConsultants = createAction(
  `${prefix} Add To Selected Consultants`,
  props<{ consultant: IUserSkill }>(),
);
export const removeFromSelectedConsultants = createAction(
  `${prefix} Remove From Selected Consultants`,
  props<{ consultant: IUserSkill }>(),
);
export const clearSelectedConsultants = createAction(
  `${prefix} Clear Selected Consultants`,
);

export const setSkillForConsultantSearch = createAction(
  `${prefix} Set Skill For Consultant Search`,
  props<{ skill: ISkillNode }>(),
);
export const clearConsultantSearch = createAction(
  `${prefix} Clear Consultant Search`,
);
